export default {
      id: "heart-usage",
      viewBox: "0 0 512 444",
      url: __webpack_public_path__ + "img/svg-sprite.svg#heart",
      toString: function () {
        return this.url;
      }
    }